<script lang="ts">
  import Sparkle from "../../icons/Sparkle.svelte";
  import { withPromiseResults } from "../../stores/promiseResults";
  import type { UnsignedMattersState } from "./UnsignedMattersState.svelte";

  let {
    manager,
    toggleHelp,
  }: {
    manager: UnsignedMattersState,
    toggleHelp: (e: Event) => void,
  } = $props();

  let plural = $derived(manager.mattersToReject.length > 1);
  let signedPlural = $derived(manager.mattersSigned.length > 1);
  let [doReject, _success, error] = withPromiseResults(manager.doReject.bind(manager));
  const matterTypeDisplayName = manager.matterType.toUpperCase();
  const matterSubject = manager.matterType == 'dpf' ? 'vehicle' : 'financial agreement';
  const canAskMeLater = manager.allowIndividualAskLater || !manager.mattersSigned.length;

  let enabled = $state(false);
  setTimeout(() => (enabled = true), 1_000);
</script>

{#if manager.mattersSigned?.length}
  <div class="mb-3 -mx-1">
    <p class="flex items-start p-2.5 border-2 border-solid border-success bg-success-200 rounded gap-3 text-base text-left">
      <Sparkle class="w-10 h-10 hidden sm:block" />
      <span><b>Success!</b> We will get to work on your {signedPlural ? "claims" : "claim"} straight away, and the details are on the next screen.</span>
    </p>
  </div>
  <p class="text-base mb-3">You also asked us not to pursue {plural ? "some claims" : "a claim"}.</p>
{:else}
  {#if manager.allowIndividualAskLater}
    <h2 class="ui-title mb-2">Pass on {plural ? "these" : "this"}?</h2>
  {:else}
    <h2 class="ui-title mb-2">You've chosen not to pursue {plural ? "these" : "this"}:</h2>
  {/if}
{/if}

<p class="text-base mb-3">
  {#if canAskMeLater}
    Just to be sure, you do not want us to pursue a {matterTypeDisplayName} claim in regard to {plural ? `these ${matterSubject}s` : `this ${matterSubject}`}, and you do not want us to ask you about {plural ? "them" : "it"} again?
  {:else}
    Please contact support if you change your mind and you want us to pursue a {matterTypeDisplayName} claim in regard to {plural ? `these ${matterSubject}s` : `this ${matterSubject}`}
  {/if}
</p>

<ul class="list-disc list-outside mb-3 ml-5">
  {#each manager.mattersToReject as matter}
    <li>{matter.title}</li>
  {/each}
</ul>

<p class="text-base mb-3">
  <a href="#what_is_{manager.matterType}" onclick={toggleHelp} class="text-primary underline">What is a {matterTypeDisplayName} claim?</a>
</p>

<div class="floating-footer">
  <div class="flex gap-2 flex-col w-full">
    {#if canAskMeLater}
      <div class="flex w-full justify-between">
        <button class="btn btn-secondary" onclick={() => manager.askLater()}>Ask me later</button>
        <button class="btn btn-error" disabled={!enabled} onclick={() => doReject()}>Do not pursue</button>
      </div>
    {:else}
      <div class="flex w-full justify-end">
        <button class="btn btn-secondary" disabled={!enabled} onclick={() => doReject()}>Continue</button>
      </div>
    {/if}
    {#if $error}
      <div class="text-sm text-error font-medium">
        <b>Something went wrong.</b> Please try again, and if it still doesn't work refresh the page.
      </div>
    {/if}
  </div>
</div>
